import React, { useState, useEffect, useContext } from 'react';

import {DcContext} from './context'; 
//import Tip from './tip';

import FormState from '../formstate';

const Single = (props) => {

	// * state 
	const [selected, setSelected] = useState("");
	const [isTabs, setIsTabs] = useState(false); 

	// * context 
	const appContext = useContext(DcContext);

	// * helpers
	const isSelectedVal = (val) => {
		let out = false;
		if (val && val !== "n/a" && val !== "") {
			out = true;
		}
		return out;
	}; 

	const isSelected = () => {
		return isSelectedVal(selected);
	}

	const autoSelect = (newProps) => {
		// auto select after reset formstate 
		const formState = appContext.getFormState(); 
		if (newProps["autoSelect"] == true) {
			if (!isSelectedVal(newProps["selected"])) {
				if (newProps.options.length >= 1) {
					//console.log('autoSelect', newProps.options[0].value );
					// set component state 
					setSelected(newProps.options[0].value); 
					// update formState
					let updateType = newProps.updateType;
					let updateVal = newProps.updateVal;
					//console.log('setSelection', updateType, updateVal, nextProps.options[0].value);
					formState.setSelection(updateType, updateVal, [newProps.options[0].value]);
					// store it in context 
					appContext.setFormState(formState);
					//console.log('autoselected'); 
				}
			}
		}
	};

	// * component mount/update
	useEffect(
		() => {
			//console.log('selected', props.selected); 
			setSelected(props.selected); 
			autoSelect(props); 
			if (props.tabs) {
				setIsTabs(true); 
			}
		},
		[props]
	); 

	// * event handlers
	const onChange = (event) => {
		//console.log(event.target.value);
		let value = event.target.value;
		const formState = appContext.getFormState(); 

		// set app state 
		const updateType = props.updateType;
		const updateVal = props.updateVal;
		//console.log('setSelection', updateType, updateVal, value, fs);
		formState.setSelection(updateType, updateVal, [value]);
		// store product selections
		if (props.product) {
			formState.addProduct(props.product);
		}
		// store it in context 
		appContext.setFormState(formState); 
		//console.log('onChange', formState.sectionItems); 
	};

	const onClear = (event) => {
		event.preventDefault();
		const formState = appContext.getFormState(); 
		const updateType = props.updateType;
		const updateVal = props.updateVal;
		//formState.clearSelection(updateType, updateVal);
		// hack 
		formState.setSelection(updateType, updateVal, ['cleared']);
		// store product selections
		if (props.product) {
			formState.removeProduct(props.product);
		}
		// store it in context 
		appContext.setFormState(formState); 
		//console.log('cleared?')
	};

	const onTabClick = (event) => {
		//console.log(event.target.getAttribute('data-value'));
		event.target.value = event.target.getAttribute('data-value')
		onChange(event);
	}


	// * render 
	const renderChecks = () => {
		let checks = [];
		props.options.forEach((opt, i) => {
			checks.push(
				<label key={i} className={selected == opt.value ? "selected" : ""}>
					<input type="radio"
						onChange={onChange}
						checked={selected == opt.value}
						name={props.name}
						value={opt.value}
					/>{opt.label}
					
				</label>
			);
			// disable tip for now
			// <Tip tipText={opt.tip} num={i} />
		});

		var optClassNames = ["option-group"];
		optClassNames.push(isSelected() ? "selected" : "unselected");
		if (!props.options || props.options.length == 0) {
			optClassNames.push("empty");
		}

		const opened = !props.closed; 

		return (
			<div className={optClassNames.join(' ')}>
				<details className='option-details' open={opened}>
					<summary>
						<h3>{props.heading}</h3>
					</summary>
					{checks}
					<a className={"clear-link " + (isSelected() ? "" : "display-none")} href='#' onClick={onClear}>clear</a>
				</details> 
			</div>
		);	

	};

	const renderTabs = () => {
		let tabs = [];
		props.options.forEach((opt, i) => {
			tabs.push(
				<li key={i} role="presentation" className={selected == opt.value ? 'active' : ''}>
					<a href="" aria-controls={opt.value} role="tab" data-toggle="tab" data-value={opt.value} onClick={onTabClick}>{opt.label}</a>
				</li>
			);
		});

		var classNames = ['nav', 'nav-tabs'];
		classNames.push((selected && selected != "n/a") ? "selected" : "unselected");
		if (!props.options || props.options.length == 0) {
			classNames.push("empty");
		}

		return (
			<div className={classNames.join(' ')}>
				<h3>{props.heading}:</h3>
				{tabs}
			</div>
		);		
	}

	return (isTabs ? 
		renderTabs() : 
		renderChecks()
	); 

}; 


export default Single;
